interface ProjectPhotoImageProps {
  src: string;
  alt?: string;
  className?: string;
  sizes?: string;
  loading?: 'lazy' | 'eager';
  width?: number;
  height?: number;
  onLoad?: (e: React.SyntheticEvent<HTMLImageElement>) => void;
  onError?: (e: React.SyntheticEvent<HTMLImageElement>) => void;
  debugContext?: string;
}

export default function ProjectPhotoImage({
  src,
  alt = 'Photo',
  className = '',
  loading = 'lazy',
  onLoad,
  onError,
}: ProjectPhotoImageProps) {
  return (
    <img
      src={src}
      alt={alt}
      loading={loading}
      decoding="async"
      className={`block w-full h-full object-cover object-center ${className}`}
      onLoad={onLoad}
      onError={onError}
    />
  );
}
